export const SET_COMPONENT_STATE = 'SET_COMPONENT_STATE';

// NOTE: Messasges in this file are intended for use with `iframeable`

export const isSetComponentStateMessage = msg => {
  const {
    payload
  } = msg;
  return payload.type === SET_COMPONENT_STATE && 'updates' in payload;
};